module.exports = __webpack_public_path__ + "img/alamanova_500.979df059.jpg";